import { styled, TextareaAutosize } from "@mui/material";
import { blue, grey } from "@mui/material/colors";

const TextArea = styled(TextareaAutosize, {
    shouldForwardProp: (prop) => prop !== "error",
})<{ error?: boolean }>(
    ({ theme, error }) => `
  box-sizing: border-box;
  width: 100%;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  margin: 0;
  border-radius: 4px;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  border: 1px solid ${error ? "#f44336" : theme.palette.mode === "dark" ? grey[700] : grey[200]};
  box-shadow: 0px 2px 2px ${
      theme.palette.mode === "dark" ? grey[900] : grey[50]
  };

  &:hover {
    border-color: ${error ? theme.palette.error.main : "rgba(0, 0, 0, 0.87)"};
  }

  &:focus {
    border-color: ${error ? theme.palette.error.main : theme.palette.primary.main};
    outline: 0;
  }

  &:focus-visible {
    outline: 0;
  }
`,
);

export default TextArea;
